<template>
  <div class="login">
    <div class="box">
      <div v-if="!wxLogin">
        <div class="logo">
          <img src="@/static/logo.png" alt="">
        </div>
        <h2 style="text-align: center;">欢迎使用AI智课</h2>
        <el-form style="margin-top: 20px;">
          <el-form-item>
            <el-input v-model="phone" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="authCode" placeholder="请输入验证码">
              <el-button
                slot="append"
                :disabled="codeTime > 0"
                @click="getCode"
              >{{ codeTitle }}</el-button>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="submit"
              style="width: 100%;"
              size="medium"
            >注册/登录</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="text" @click="wxLogin = !wxLogin" size="medium">微信登录</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div v-else>
        <el-button type="text" size="medium" @click="wxLogin = !wxLogin"><i class="el-icon-back"></i>返回</el-button>
        <WxLogin/>
      </div>
    </div>
    <!-- 滑动验证 -->
    <Vcode :show="dialogVisible" @success="codeSuccess" :imgs="[img2, img1]"></Vcode>
  </div>
</template>

<script>
import Vcode from 'vue-puzzle-vcode'
import { setStorage, getStorage, removeStorage } from '@/utils/storage'
import { mapMutations } from 'vuex'

import { sendMessageCode, getSlideCode, getWxOpen, bindPhoneApi } from '@/api/system.js'
import WxLogin from '@/components/wx-login.vue'
export default {
  name: 'login',
  components: {
    Vcode,
    WxLogin
  },
  data() {
    return {
      timer: null,
      codeTitle: '获取验证码',
      codeTime: 0, //验证码定时
      phone: '', //手机号
      authCode: '', // 验证码
      dialogVisible: false, //打开验证码框
      inviteCode: '', //邀请码
      uuid: '',
      bindPhoneFlag: '',
      img1: '',
      img2: '',
      random: '',
      wxLogin: false
    }
  },
  mounted() {
    let urlStr = window.location.href
    let a = urlStr.split('?')[1]

    if (a && a.split('=')[0] === 'invite_code') {
      setStorage({
        name: 'inviteCode',
        content: a.split('=')[1],
      })
      this.inviteCode = getStorage({ name: 'inviteCode' })
    }
  },
  methods: {
    ...mapMutations(['SET_IS_LOGIN']),
    // 验证通过
    codeSuccess() {
      this.dialogVisible = false
      let params = {
        phone: this.phone,
        random: this.random,
      }
      this.$showLoading({
        text: '校验中',
      })
      sendMessageCode(params)
        .then((res) => {
          this.$hideLoading({
            message: '校验成功',
            type: 'success',
          })
          // 验证码定时
          this.codeTime = 60
          this.codeTitle = this.codeTime + '秒后重新获取'
          this.timer = setInterval(() => {
            if (this.codeTime > 0) {
              this.codeTime--
              this.codeTitle = this.codeTime + '秒后重新获取'
            } else {
              clearInterval(this.timer)
              this.codeTime = 0
              this.codeTitle = '获取验证码'
            }
          }, 1000)
        })
        .catch((err) => {
          this.$hideLoading({
            message: '校验失败',
            type: 'error',
          })
        })
    },
    // 获取验证码
    getCode() {
      let check = this.formCheck(this.phone)
      if (!check.flag) {
        return this.$message.error(check.info)
      }

      let params = {
        index: 3,
        phone: this.phone,
        type: 'pc',
      }
      getSlideCode(params).then((res) => {
        this.img1 = 'data:image/png;base64,' + res.data.image1
        this.img2 = 'data:image/png;base64,' + res.data.image2

        this.random = res.data.random
        this.dialogVisible = true
      })
    },
    // 验证手机号
    formCheck(value) {
      let reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (!value) {
        return {
          info: '请输入手机号!',
          flag: false,
        }
      } else if (!reg.test(value)) {
        return {
          info: '请输入正确的手机号!',
          flag: false,
        }
      } else {
        return {
          flag: true,
        }
      }
    },
    // 登录
    submit() {
      let check = this.formCheck(this.phone)
      if (!check.flag) {
        return this.$message.error(check.info)
      }
      if (this.authCode === '') {
        return this.$message({
          message: '请获取验证码登录!',
        })
      } else if (this.authCode.length != 6) {
        return this.$message({
          message: '请输入正确的验证码!',
        })
      }
      this.$showLoading({
        text: '登录中',
      })
      this.$store
        .dispatch('LoginBySocial', {
          params: {
            loginType: 'wxmini',
            grantType: 'wxmini',
            invite_code: this.inviteCode ? this.inviteCode : '',
            phone: this.phone,
            phoneCode: this.authCode,
            login_type: 'phone',
          },
          meta: {
            Authorization: 'd3htaW5pOnd4bWluaV9zZWNyZXQ=',
          },
        })
        .then((res) => {
          if (getStorage({ name: 'inviteCode' })) {
            removeStorage({
              name: 'inviteCode',
            })
          }
          this.$hideLoading({
            message: '登录成功',
            type: 'success',
          })
          this.$router.replace({
            name: 'Course',
          })
        })
        .catch(() => {
          this.$hideLoading({
            message: '登录失败',
            type: 'error',
          })
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100vh;
  background-color: #FFFFFF;

  .box {
    position: relative;
    top: 110px;
    width: 500px;
    min-height: 400px;
    margin: 0 auto;
    border-radius: 10px;
    border: 1px solid #e0e0e0;
    padding: 30px;
  }
  .logo {
    // width: 130px;
    width: 178px;
    // height: 40px;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
    }
    margin-bottom: 30px;
  }
  ::v-deep {
    .el-input input {
      height: 42px;
      line-height: 42px;
      font-size: 15px;
    }
  }
}
</style>